/* Elbury — header, mega menu, mobile menu, search, basket drawer, size guide */
(function () {
  'use strict';
  var d = document;
  var $ = function (s, r) { return (r || d).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); };
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* ---------- helpers ---------- */
  function money(cents) { return '£' + (cents / 100).toFixed(2); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function img(url, w) {
    if (!url) return '';
    if (url.indexOf('//') === 0) url = 'https:' + url;
    return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'width=' + (w || 300);
  }
  function addWork(dt, n) { var x = new Date(dt); while (n > 0) { x.setDate(x.getDate() + 1); var w = x.getDay(); if (w !== 0 && w !== 6) n--; } return x; }
  function fmtD(dt) { return dt.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' }).replace(',', ''); }
  function fmtS(dt) { return dt.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' }); }
  var UK = { 34: '2', 35: '2.5', 36: '3.5', 37: '4', 38: '5', 39: '6', 40: '6.5', 41: '7', 42: '8', 43: '9', 44: '9.5', 45: '10.5', 46: '11', 47: '12', 48: '12.5', 49: '13.5', 50: '14', 21: '4.5 C', 22: '5.5 C', 23: '6 C', 24: '7 C', 25: '8 C', 26: '8.5 C', 27: '9.5 C', 28: '10 C', 29: '11 C', 30: '12 C', 31: '12.5 C', 32: '13.5 C', 33: '1', 36.5: '4' };
  function cm(n) { return (n >= 33 ? (22 + (n - 34) * 0.5) : (13 + (n - 21) * 0.6)).toFixed(1) + ' cm'; }
  var TINTS = ['#E9E3DA', '#E4DDD2', '#EDE7DE', '#E2DBD0'];
  var store = {
    get: function (k) { try { return JSON.parse(localStorage.getItem(k) || 'null'); } catch (e) { return null; } },
    set: function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  };

  /* ---------- delivery dates ---------- */
  var today = new Date();
  var ETA = { disp: fmtD(addWork(today, 2)), range: fmtS(addWork(today, 8)) + ' – ' + fmtS(addWork(today, 10)) };
  function fillEta(scope) { $$('[data-eta]', scope).forEach(function (el) { el.textContent = ETA[el.getAttribute('data-eta')] || ''; }); }

  /* ---------- recently viewed ---------- */
  if (window.EB_SEEN_ADD && window.EB_SEEN_ADD.u) {
    var seen = (store.get('eb-seen') || []).filter(function (p) { return p && p.u !== window.EB_SEEN_ADD.u; });
    seen.unshift(window.EB_SEEN_ADD);
    store.set('eb-seen', seen.slice(0, 8));
  }

  function card(p, i) {
    return '<a class="eb-card" href="' + esc(p.u) + '"><span class="eb-tile" style="background: ' + TINTS[(i || 0) % 4] + '">' +
      (p.i ? '<img src="' + esc(p.i) + '" alt="' + esc(p.t) + '" loading="lazy">' : '') +
      '</span><span class="eb-ct"><span class="eb-t">' + esc(p.t) + '</span><span class="eb-p"><b>' + esc(p.p) + '</b></span></span></a>';
  }

  function init() {
    var top = $('#eb-top'), layer = $('#eb-layer');
    if (!top || !layer) return;
    if (layer.parentNode !== d.body) d.body.appendChild(layer);
    fillEta(layer);

    var shade = $('.eb-shade', layer);
    var panels = { cart: $('#eb-cart'), size: $('#eb-size'), search: $('#eb-search'), menu: $('#eb-menu') };
    var current = '';

    function closeAll() {
      Object.keys(panels).forEach(function (k) { if (panels[k]) panels[k].hidden = true; });
      shade.hidden = true; current = '';
      d.documentElement.classList.remove('eb-lock');
    }
    function open(x) {
      closeMega();
      Object.keys(panels).forEach(function (k) { if (panels[k]) panels[k].hidden = k !== x; });
      shade.hidden = false; current = x;
      d.documentElement.classList.add('eb-lock');
      if (x === 'cart') renderCart(window.EB_CART || null, true);
      if (x === 'search') { var q = $('#eb-q'); runSearch(q.value); setTimeout(function () { q.focus(); }, 30); }
      if (x === 'size') sgTab('Women');
    }
    window.ebOpen = open; window.ebClose = closeAll;

    d.addEventListener('click', function (e) {
      var o = e.target.closest('[data-eb-open]');
      if (o) { e.preventDefault(); open(o.getAttribute('data-eb-open')); return; }
      if (e.target.closest('[data-eb-close]')) { e.preventDefault(); closeAll(); }
    });
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeAll(); closeMega(); } });

    /* ----- mega menu ----- */
    var hdr = $('#eb-hdr'), navLinks = $$('.eb-nav [data-mega]', hdr), cur = top.getAttribute('data-cur') || '';
    function setNav(k) { navLinks.forEach(function (a) { var m = a.getAttribute('data-mega'); a.classList.toggle('eb-on', !!m && (m === k || (!k && m === cur))); }); }
    function showMega(k) {
      $$('[data-mega-panel]', hdr).forEach(function (p) { p.hidden = p.getAttribute('data-mega-panel') !== k; });
      setNav(k);
    }
    function closeMega() { showMega(''); }
    navLinks.forEach(function (a) { a.addEventListener('mouseenter', function () { showMega(a.getAttribute('data-mega')); }); });
    hdr.addEventListener('mouseleave', closeMega);

    /* ----- mobile menu tabs ----- */
    $$('[data-mm]', layer).forEach(function (b) {
      b.addEventListener('click', function () {
        var k = b.getAttribute('data-mm');
        $$('[data-mm]', layer).forEach(function (x) { x.classList.toggle('eb-on', x === b); });
        $$('[data-mm-panel]', layer).forEach(function (p) { p.hidden = p.getAttribute('data-mm-panel') !== k; });
      });
    });

    /* ----- size guide ----- */
    function rows(a) { return a.map(function (n) { return { eu: String(n), uk: UK[n] || '—', cm: cm(n) }; }); }
    function sgTab(t) {
      $$('[data-sg]', layer).forEach(function (b) { b.classList.toggle('eb-on', b.getAttribute('data-sg') === t); });
      var r;
      if (t === 'Women') r = rows([34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44]);
      else if (t === 'Men') r = rows([38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50]);
      else r = [{ eu: '0–6 months', uk: '0–2 C', cm: '10–11 cm' }, { eu: '6–12 months', uk: '2–3 C', cm: '11–12 cm' }, { eu: '12–18 months', uk: '3–4 C', cm: '12–13 cm' }].concat(rows([21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32]));
      $('#eb-sg-rows').innerHTML = r.map(function (x) { return '<tr><td><b style="font-weight: 600">' + x.eu + '</b></td><td>' + x.uk + '</td><td>' + x.cm + '</td></tr>'; }).join('');
    }
    $$('[data-sg]', layer).forEach(function (b) { b.addEventListener('click', function () { sgTab(b.getAttribute('data-sg')); }); });

    /* ----- search ----- */
    var qEl = $('#eb-q'), sTimer = null, sSeq = 0;
    function runSearch(v) {
      var q = (v || '').trim(), my = ++sSeq;
      var sug = $('#eb-sug'), res = $('#eb-res'), none = $('#eb-none');
      if (q.length >= 2) {
        sug.hidden = false;
        $('#eb-sug-list').innerHTML = [[' moccasins women', 'women'], [' moccasins men', 'men'], [' for kids', 'kids']].map(function (x) {
          return '<a href="' + root + 'search?type=product&q=' + encodeURIComponent(q + ' ' + x[1]) + '"><mark>' + esc(q) + '</mark>' + x[0] + '</a>';
        }).join('');
      } else sug.hidden = true;
      if (!q) {
        var seenList = store.get('eb-seen') || [];
        none.hidden = true;
        res.hidden = !seenList.length;
        $('#eb-res-title').textContent = 'Recently viewed';
        $('#eb-res-grid').innerHTML = seenList.slice(0, 8).map(card).join('');
        return;
      }
      fetch(root + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last')
        .then(function (r) { return r.json(); })
        .then(function (j) {
          if (my !== sSeq) return;
          var ps = (j.resources && j.resources.results && j.resources.results.products) || [];
          if (!ps.length) { res.hidden = true; none.hidden = false; $('#eb-none-q').textContent = q; return; }
          none.hidden = true; res.hidden = false;
          $('#eb-res-title').textContent = ps.length + ' product' + (ps.length > 1 ? 's' : '') + ' for “' + q + '”';
          $('#eb-res-grid').innerHTML = ps.map(function (p, i) {
            return card({ u: p.url, t: p.title, p: '£' + Number(p.price).toFixed(2), i: p.image ? img(p.image, 600) : '' }, i);
          }).join('');
        }).catch(function () {});
    }
    qEl.addEventListener('input', function () { clearTimeout(sTimer); sTimer = setTimeout(function () { runSearch(qEl.value); }, 180); });
    $$('[data-q]', layer).forEach(function (b) { b.addEventListener('click', function () { qEl.value = b.getAttribute('data-q'); runSearch(qEl.value); qEl.focus(); }); });

    /* ----- basket ----- */
    var countEl = $('#eb-count');
    function setCount(n) { countEl.textContent = n; countEl.hidden = !n; }

    function optMeta(item) {
      var col = '', size = '';
      (item.options_with_values || []).forEach(function (o) {
        var n = (o.name || '').toLowerCase();
        if (n.indexOf('size') >= 0 || n.indexOf('taille') >= 0) size = o.value;
        else if (!col) col = o.value;
      });
      var parts = [];
      if (col) parts.push(esc(col));
      if (size) { var num = parseFloat(size); parts.push(/^\d+(\.\d+)?$/.test(size) ? 'EU ' + esc(size) + (UK[num] ? ' (UK ' + UK[num] + ')' : '') : esc(size)); }
      return parts.join(' · ');
    }

    function renderCart(c, refetch) {
      if (refetch || !c) { fetchCart(); if (!c) return; }
      window.EB_CART = c;
      setCount(c.item_count);
      var empty = !c.item_count;
      $('#eb-cart-empty').hidden = !empty;
      $('#eb-cart-foot').hidden = empty;
      $('#eb-cart-total').textContent = money(c.total_price);
      $('#eb-cart-lines').innerHTML = c.items.map(function (it, i) {
        return '<div class="eb-line" data-key="' + esc(it.key) + '"><a class="eb-tile" href="' + esc(it.url) + '" style="background: ' + TINTS[i % 4] + '">' +
          (it.image ? '<img src="' + esc(img(it.image, 300)) + '" alt="' + esc(it.product_title) + '">' : '') + '</a>' +
          '<div><h4><a href="' + esc(it.url) + '">' + esc(it.product_title) + '</a></h4><div class="eb-meta">' + optMeta(it) + '</div>' +
          '<div style="display: flex; align-items: center"><span class="eb-qty"><button type="button" aria-label="Decrease quantity" data-q-ch="-1">−</button><span>' + it.quantity + '</span><button type="button" aria-label="Increase quantity" data-q-ch="1">+</button></span><button type="button" class="eb-rm" data-q-rm>Remove</button></div></div>' +
          '<div class="eb-lp">' + money(it.final_line_price) + '</div></div>';
      }).join('');
      renderCtl(c);
    }
    var ctlFor = null;
    function renderCtl(c) {
      var box = $('#eb-ctl');
      if (!c.items.length) { box.hidden = true; ctlFor = null; return; }
      var pid = c.items[0].product_id;
      if (ctlFor === pid) return;
      ctlFor = pid;
      var inCart = c.items.map(function (x) { return x.product_id; });
      fetch(root + 'recommendations/products.json?product_id=' + pid + '&limit=6&intent=related')
        .then(function (r) { return r.json(); })
        .then(function (j) {
          var p = (j.products || []).filter(function (x) { return inCart.indexOf(x.id) < 0 && x.available; })[0];
          if (!p) { box.hidden = true; return; }
          $('#eb-ctl-c').innerHTML = '<div class="eb-ctl-c"><span class="eb-tile" style="background: ' + TINTS[1] + '">' +
            (p.featured_image ? '<img src="' + esc(img(p.featured_image, 200)) + '" alt="' + esc(p.title) + '">' : '') +
            '</span><div><b style="font-weight: 600">' + esc(p.title) + '</b><span>' + esc(p.type || '') + '</span><span style="color: #191714">' + money(p.price) + '</span></div><a class="eb-ctl-b" href="' + esc(p.url) + '">Choose size</a></div>';
          box.hidden = false;
        }).catch(function () { box.hidden = true; });
    }
    function fetchCart() {
      return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { renderCart(c); return c; });
    }
    function change(key, qty) {
      return fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
        .then(function (r) { return r.json(); }).then(function (c) { renderCart(c); return c; });
    }
    $('#eb-cart-lines').addEventListener('click', function (e) {
      var line = e.target.closest('.eb-line'); if (!line) return;
      var key = line.getAttribute('data-key');
      var it = (window.EB_CART.items || []).filter(function (x) { return x.key === key; })[0]; if (!it) return;
      var ch = e.target.closest('[data-q-ch]');
      if (ch) { change(key, Math.max(0, it.quantity + parseInt(ch.getAttribute('data-q-ch'), 10))); return; }
      if (e.target.closest('[data-q-rm]')) change(key, 0);
    });

    /* public API used by product pages */
    window.ebCart = {
      add: function (variantId, qty, props) {
        var body = { items: [{ id: variantId, quantity: qty || 1, properties: props || {} }] };
        return fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
          .then(function (r) { if (!r.ok) return r.json().then(function (j) { throw j; }); return r.json(); })
          .then(function () { return fetchCart(); })
          .then(function (c) { open('cart'); return c; });
      },
      refresh: fetchCart,
      open: function () { open('cart'); }
    };
    /* keep the count right if a native theme form adds to the basket */
    d.addEventListener('cart:update', function () { fetchCart(); });
  }

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
})();
